<template>
  <div class="stat-number d-flex flex-column justify-content-center align-center">
    <div class="stat-value">
      <slot name="default"></slot>
      <slot name="stat"></slot>
    </div>
    <div class="stat-label subtext">{{ label }}</div>
  </div>
</template>

<script>

export default {
  name: 'StatNumber',
  props: ['label']
}
</script>

<style lang="scss">
.stat-number {
  .stat-value {
    font-size: 1.3em;
  }

  .stat-label {

  }
}
</style>
